import React from "react";
import { Link } from "react-router-dom";

const MAP_EMBED_URL =
  "https://www.google.com/maps?cid=5313368473858328249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAEYASAB&hl=en&gl=ID&source=embed&output=embed";

export default function Footer() {
  return (
    <footer style={{ background: "#2c3d33" }} className="py-14 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="text-white text-xs tracking-widest font-light leading-tight">
                BUM DESA
                <br />
                WARGA DEKAT BANDUNG
              </span>
            </div>
            <p className="text-gray-400 text-xs leading-relaxed">
              Badan Usaha Milik Desa yang berkomitmen memberdayakan ekonomi
              lokal dan meningkatkan kesejahteraan masyarakat Desa Puhu,
              Ciwidey.
            </p>
          </div>

          {/* Navigasi */}
          <div>
            <h3 className="text-white text-xs font-semibold tracking-wider mb-4 uppercase">
              Navigasi
            </h3>
            <ul className="space-y-2">
              {[
                ["Home", "/"],
                ["About Us", "/about-us"],
                ["Products", "/products"],
                ["Services", "/services"],
                ["News", "/news"],
                ["Contact", "/contact"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-gray-400 text-xs hover:text-white transition"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Kontak */}
          <div>
            <h3 className="text-white text-xs font-semibold tracking-wider mb-4 uppercase">
              Hubungi Kami
            </h3>
            <div className="space-y-2 text-xs text-gray-400">
              <p>
                📍 Bukit Sinyonya
                <br className="hidden" />
                Batulingga, Bandung, Kec. Banjar, Kabupaten Pandeglang, Banten
                42252
              </p>
              <p>📞 082113216292</p>
              <p>✉️ info@bumdesa-puhu.id</p>
              <p className="mt-3 text-gray-500">
                Senin–Kamis: 08.00–16.00
                <br />
                Jumat: 08.00–11.30
                <br />
                Sabtu: 08.00–14.00
              </p>
            </div>
          </div>

          {/* Map */}
          <div>
            <h3 className="text-white text-xs font-semibold tracking-wider mb-4 uppercase">
              Lokasi
            </h3>
            <div
              className="rounded-lg overflow-hidden"
              style={{ height: "130px" }}
            >
              <iframe
                src={MAP_EMBED_URL}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Lokasi BUM Desa"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-2">
          <p className="text-gray-500 text-xs">
            © 2025 BUM Desa Warga Dekat Bandung. All rights reserved.
          </p>
          <p className="text-gray-600 text-xs">
            Dikelola oleh BUM Desa Warga Dekat Bandung
          </p>
        </div>
      </div>
    </footer>
  );
}
